export var HomepageComponentTypes;
(function (HomepageComponentTypes) {
    HomepageComponentTypes[HomepageComponentTypes["ARTICLES"] = 10] = "ARTICLES";
    HomepageComponentTypes[HomepageComponentTypes["CATEGORIES"] = 20] = "CATEGORIES";
})(HomepageComponentTypes || (HomepageComponentTypes = {}));
//# sourceMappingURL=widget-kb-module-settings.i.js.map